import React from 'react';

const ContactUsPage: React.FC = () => {
  return (
    <div>
      <main>
        <div className="container">
          <h1>Contact Us</h1>
          <p>
            For all business inquiries, feel free to get in touch with us using
            the contact details provided in the footer below or by placing an
            order.
          </p>
          <p>You can also reach out to us via Facebook.</p>
          <p>We look forward to hearing from you!</p>
        </div>
      </main>
    </div>
  );
};

export default ContactUsPage;
